import { useState } from 'react'
import { useAppContext } from '../../contexts/AppContext'
import { AppActionType } from '../../contexts/AppReducer'
import { AttachIcon } from '../../icons/AttachIcon'
import { SmileIcon } from '../../icons/SmileIcon'
import { EditTextArea } from '../EditTextArea'
import './style.scss'

export interface AddEntryProps {}

export function AddEntry() {
  const { dispatch } = useAppContext()

  const [content, setContent] = useState('')

  const handleSubmit = () => {
    if (!content) {
      return
    }

    dispatch({
      type: AppActionType.AddEntry,
      data: content,
    })
    setContent('')
  }

  return (
    <div className='add-entry'>
      <EditTextArea placeholder='Your text here' value={content} onChange={setContent} />
      <div className='add-entry__bottom'>
        <div className='add-entry__bottom__actions'>
          <button className='button-svg' aria-label='attach'>
            <AttachIcon />
          </button>

          <button className='button-svg' aria-label='smile'>
            <SmileIcon />
          </button>
        </div>

        <button className='button-primary' onClick={handleSubmit}>
          SUBMIT
        </button>
      </div>
    </div>
  )
}
